import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

/// LISTADO DE PASOS DE WIZARD DE CADA PRODUCTO
import { actionSteps } from './action/action.steps';


//PASOS DE PRODUCTOS CERTIFICAR


///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_izzi } from 'app/idiomas/i18n/Izzi/izzi.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import *  as $ from 'jquery';
import {AuthService} from 'app/auth/auth.service';
import { WizardActionService } from './services/wizard.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'wizard-action',
  templateUrl: './wizard-action.component.html',
  styleUrls: ['./wizard-action.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class WizardActionComponent{

  animationDirection: 'left' | 'right' | 'none';
  currentStep: number;
  lastStep: number;
  iconoStep: any = {
    undone: 'lock',
    pending: 'more_horiz',
    done: 'done'
  };

  pasosWizard: any;
  tituloProducto: string;
  tipoProducto: string;
  idiomaActual:string;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  // Plantilla de certificar para validacion
  idPlantilla:any;
  // objeto statuses
  statusSteps: backInter.getAllStatus;
  statusStepsFocus: any;
  // datos producto vigente
  productoVigente: any;
  // año producto productoVigente
  anioProducto: number;

  //booleans de los steps
  stp1Ok = false;

  stpAllOk = false;

  //mensaje enviado desde components hijos al component wizard CGO
  mensajeEntreComponents: string;

  idiomaVideo:string;

  //booleans secciones removibles
  hasForall = true;
  hasDemog = true;
  hasAdici = true;
  hasReact = true;
  hasOpen = true;
  //booleans secciones removibles
  hasForallT1 = true;
  hasDemogT1 = true;
  hasAdiciT1 = true;
  hasReactT1 = true;
  hasOpenT1 = true;
  hasNpsT1=true;
  hasControlT1=true;
  instituto:any;

  seccionesDisponibles = {
    Forall: false,
    Demograficos: false,
    Adicionales: false,
    Reactivos: false,
    Abiertas: false,
    NPS: false,
    Control: false
  };



  listaProdsMedir: any[] = [];
  listaProdsPulse: any[] = [];
  listaProdsLeaderGo: any[] = [];
  listaProdsActionGo: any[] = [];
  listaProdsFocus: any[] = [];
  idsProductosCert3Falsos = [
    {id:41, activo: false}, // medir 3.0
    {id:42, activo: false}, // pulse check 3.0
    {id:43, activo: false}, // focus 3.0
    {id:53, activo: false}, // focus 3.0
    {id:54, activo: false}, // focus 3.0
  ];

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseSidebarService: FuseSidebarService,
    private dialog: MatDialog,
    public authService: AuthService,
    private wizardService: WizardActionService,
    private translateSrv: TranslateService,
    private activatedRoute:ActivatedRoute,
  )
  {
    this.statusSteps = null;
    this.statusStepsFocus = null;
    this.tipoProducto = null;
    this.animationDirection = 'none';
    this.currentStep = 0;
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_izzi.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    // orden de actualizacion de botones del wizard
    this.wizardService.mensajeActual.subscribe( (resu) => {
      this.mensajeEntreComponents = resu;
      switch(this.mensajeEntreComponents){
        case "100":
        // this.getTodosLosStatus();
          // this.validarProductoActualCorrecto(); //pasa por un filtro que revisa todos los productos almacenados en caché y obtiene el bueno para hacer el get secciones, no tengo idea porque se quedan y/o porque no se borran los que no son, ahi luego lo arreglo alv
        // this.getSeccionesProducto(this.tipoProducto,"via 2");
        this.obtieneProductoActual(this.tipoProducto);
        break;
      }
    });

    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; this.cambiaIdiomaVideo(this.idiomaActual,this.currentStep); });
  }



  ngOnInit(): void
  {
    // this.limpiaVariables();
    this.obtieneOrigen();
    this.obtieneInstituto();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; break;
      case '14': case 'GCTI': this.instituto = 'GCTI'; break;
      case '15': case 'ESP': this.instituto = 'ESP'; break;
    }
    console.log("INSTITUTO "+this.instituto);
  }

  cambiaIdiomaVideo(idioma:string, step:number){
    this.idiomaVideo = this.translateSrv.currentLang;
    // switch(idioma){
    //   case 'es': this.idiomaVideo = idioma; break;
    //   default: this.idiomaVideo = 'en';
    // }
    setTimeout( () => {
      // let url = './assets/video/wizard/certificar/banner/' + this.idiomaVideo + '/' + this.pasosWizard[step].videoBanner + '.mp4';
      console.log(this.pasosWizard);
      console.log(step);
      let url = DATOS_API.urlAssets + 'video/wizard/certificar/banner/' + this.idiomaVideo + '/' + this.pasosWizard[step].videoBanner + '.mp4';
      console.log("URL");
      console.log(url);
      $("#videoBanner"+step).attr("src",url);
    },200);
  }

  obtieneOrigen(){
    this.activatedRoute.data.subscribe(params => {
      // console.log(params.producto);
      switch(params.producto){
        case "A1":
        this.pasosWizard = actionSteps;
        this.tituloProducto = 'WIZARD.ACTION_GO.TITULO_PRODUCT';
        console.log('entro este visne Action Go ');
        break;
      }
      let wizardOriginal = JSON.parse(JSON.stringify(this.pasosWizard));
      console.log("wizardOriginal:",wizardOriginal);

      this.limpiaVariables();
      this.tipoProducto = params.producto;
      localStorage.setItem('tipoProducto', params.producto);
      this.obtieneProductoActual(params.producto);

      this.idiomaActual = this.translateSrv.currentLang;
      this.cambiaIdiomaVideo(this.idiomaActual,0);
    });
  }

  limpiaVariables(){
    console.log("limpia variables del wizard");

    this.productoCertificar = null;
    this.statusSteps = null;
    this.statusStepsFocus = null;
    this.productoVigente = null;
    this.pasosWizard.forEach(paso => {
      paso.status = 1;
      // paso.visible = false;
    });
  }

  filtraProductosMedir(productos:backInter.infoProductos){
    this.listaProdsLeaderGo = [];
    let arrayLeaderGo:any[] = [];
    let arrayActionGo:any[] = [];

    productos.productosCertificar.forEach((producto:any) => {
      if(this.idsProductosCert3Falsos.findIndex(item => item.id == producto.idProducto) == -1){ //si el id del producto no esta en el arreglo

      }
      else{
        switch (producto.idProducto) {
          case 54:  //ActionGo 3.0
            arrayActionGo.push(producto);
            this.idsProductosCert3Falsos[4].activo = true;
          break;
        }
      }
    });
    this.listaProdsActionGo.push(
      {id:54, lista: arrayActionGo},
    );
// console.log('listaProdsPulse',this.listaProdsPulse);
console.log('listaProdsLeaderGo',this.listaProdsLeaderGo);


  }


  /// obtiene el producto solicitado vigente
  obtieneProductoActual(tipoProducto:string){
    this.wizardService.getProductos().subscribe((data:backInter.infoProductos) => {
      // let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      console.log(data);
      let actionGoXAno:any[]=[];
      this.filtraProductosMedir(data);
      let productoSolicitado:any;
      switch(tipoProducto){
        case "A1":
        this.listaProdsActionGo[0].lista.forEach(element => {
          console.log('localStorage.getItemproductoID',localStorage.getItem('productoID'));

          if (element.idCertificar==localStorage.getItem('productoID')) {
            console.log('encontroUno');
            actionGoXAno.push(element);
          }
        });
        productoSolicitado = actionGoXAno;

        break;
      }
      console.log('productoSolicitado',productoSolicitado);
      var BreakException = {};
      try {
        productoSolicitado.forEach( (producto) => {
          let fecha : number;
          let idProducto : string;
          switch(tipoProducto){
           case "A1":
              fecha = producto.fechaCertificar;
              idProducto = producto.idCertificar;
            break;
          }
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoVigente = producto;
            this.anioProducto = parseInt(localStorage.getItem('fechaProducto'));
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      console.log("productoVigente:",this.productoVigente);

      // obtiene el estado de las secciones removibles
      this.getSeccionesProducto(tipoProducto,"via 1");

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getSeccionesProducto(tipoProducto:string, via:string){
    console.log('get secciones');

    switch(tipoProducto){
      case "A1":
      console.log('get todos los estatus ');
      this.getTodosLosStatus();
      break;
    }

  }

  getTodosLosStatus(){
    //obtiene el status del paso idiomas del producto vigente
    switch(this.tipoProducto){
      case "A1":
      console.log('entro este caso',this.productoVigente.idCertificar);
      this.wizardService.getAllStatus(this.productoVigente.idCertificar).subscribe( (data: backInter.getAllStatus) => {
        console.log("estatus secciones :",data);
        this.colocaStatusInfo(data);
      });
      break;
    }
  }

  colocaStatusInfo(data: backInter.getAllStatus){
    this.statusSteps = data;
    console.log("statusSteps:",this.statusSteps);

    switch (this.tipoProducto) {
      case "A1":   //Certificar 3.0
      this.configuraStepsLeaderGo();
      break;
      default:    //resto de productos
    }
    this.actualizaStatusStepWizard();
  }






configuraStepsLeaderGo(){

  let statusActualizar = ["emailEdit","leaderSelect","confirmacion","avance"];
  let lang = this.statusSteps.estatusSecciones.idiomas;
  let leaderSelect = this.statusSteps.estatusSecciones.leaderSelect;
  let emailEdit = this.statusSteps.estatusSecciones.emailEdit;
  let confirmacion = this.statusSteps.estatusSecciones.confirmacion;
  let avance = this.statusSteps.estatusSecciones.avance;

if (lang==3) {
  console.log("aqui si llego 1");

  if (leaderSelect==1) {
    console.log("aqui si llego 2.0");
    this.actualizaPaso(statusActualizar[0],2)
  }else if(leaderSelect==2) {
    console.log("aqui si llego 2.1");
    // this.actualizaPaso(statusActualizar[0],2)
  }

  if(leaderSelect==3) {
    if (emailEdit==1) {
        this.actualizaPaso(statusActualizar[1],2)
    }
  }

  if(emailEdit==3) {
    if (confirmacion==1) {
      console.log('desbloquea el paso de confirmación');
        this.actualizaPaso(statusActualizar[2],2)
    }
  }

  if (leaderSelect==3 && emailEdit==3 && confirmacion==3) {
    if (avance==1) {
      this.actualizaPaso(statusActualizar[3],2);
    }
  }
  // else{
  //   if (avance==2) {
  //   // this.actualizaPaso(statusActualizar[3],2);
  // }
  // }
}
}




actualizaPaso(paso:string, status:number){
console.log('paso',paso);
console.log('status',status);

  let datos: any;
  let anioProd: any;
  switch(this.tipoProducto){
 case "A1": anioProd = this.productoVigente.idCertificar; break;
  }
  switch(paso){
    case 'idiomas' : datos = {idiomas: status}; break;
    case 'leaderSelect' : datos = {leaderSelect: status}; break;
    case 'emailEdit' : datos = {emailEdit: status}; break;
    case 'confirmacion': datos = {confirmacion: status}; break;
    case 'avance' : datos = {avance: status}; break;
  };
  console.log("datos a enviar:",datos);
  switch(this.tipoProducto){
    case "A1": //certificar v2 y 3 nuevo instituto
    this.wizardService.guardaStatusStep(datos, anioProd).subscribe( (data: backInter.RespuestaGen) => {
      this.buscaCodigoSuccess(data);
    });
    break;

  }
}

buscaCodigoSuccess(data: backInter.RespuestaGen){
  console.log("buscaCodigoSuccess",data);

  let codigosSuccess = ['210','211','212','213','214','215','216','217','218','219','220','222'];
  if(codigosSuccess.includes(data.message)){
    this.getTodosLosStatus();
  }
}

actualizaStatusStepWizard(){
  switch(this.tipoProducto){
    case "A1": this.actualizaCertificarT3(); break;
  }
  //estados de pasos: 1=bloqueado, 2=desbloqueado 3=terminado

  this.stpAllOk = true;
  // console.log(this.pasosWizard);
}



actualizaCertificarT3(){
  // console.log("Certificar 3.0");
  // console.log(this.pasosWizard);

  this.pasosWizard.forEach((paso) => {
    // paso.status = 2;
    paso.status = 2;
    if(paso.idSeccion){
      paso.visible = this.seccionesDisponibles[paso.idSeccion];
    }
  });
  console.log("pasosWizardCT3:",this.pasosWizard);

}



gotoStep(step): void
{
  this.animationDirection = this.currentStep < step ? 'left' : 'right';
  //this._changeDetectorRef.detectChanges();

  this.lastStep = this.currentStep;

  this.currentStep = step;

  // console.log(this.animationDirection);
  this.cambiaIdiomaVideo(this.idiomaActual,step);
}

gotoNextStep(): void
{
  // if ( this.currentStep === this.course.totalSteps - 1 )
  if ( this.currentStep === this.pasosWizard.length - 1 )
  {
    return;
  }
  this.animationDirection = 'left';
  //this._changeDetectorRef.detectChanges();
  this.currentStep++;
}

gotoPreviousStep(): void
{
  if ( this.currentStep === 0 )
  {
    return;
  }
  this.animationDirection = 'right';
  //this._changeDetectorRef.detectChanges();
  this.currentStep--;
}

toggleSidebar(name): void
{
  this._fuseSidebarService.getSidebar(name).toggleOpen();
}

aletaRestric(opc:number){
  let texto: string;
  switch(this.tipoProducto){
    case '1':
    switch(opc){
      case 1: case 2: case 3: case 4: case 5: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest1'; break;
      case 6: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest5'; break;
      case 7: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 8: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest3'; break;
      case 9: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest4'; break;
    }
    break;
    case '2':
    switch(opc){
      case 1: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest1'; break;
      case 2: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 3: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 4: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 5: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
    }
    break;
  }

  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  Swal.fire({
    html: texto,
    icon: 'error',
    confirmButtonColor: '#e40601'
  });
}

// enviarCorreos(){
//   console.log('enviando correos electronicos');
//
// }
}
